import React, { Component } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import logo from '../../../images/logo.svg'

class LogoTrapInk extends Component {
  render() {
    return (
      <img className={ classnames('logo-trap-ink', this.props.className) } src={ logo } alt="logo" />
    );
  }
}

LogoTrapInk.propTypes = {
  className: PropTypes.string
}

export default LogoTrapInk;



// WEBPACK FOOTER //
// ./src/components/logos/trapink/index.js